import React from "react";
import { Drawer } from "../../components/Modals";
import DashboardDetails from "../DashboardNew/RoadMapDetails";
import Portal from "../../components/Portal";

interface ShowSingleProjectModalProps {
  closeModal: () => void;
  isVisible: boolean;
  project_id: string;
  taskData: any;
}

const ShowSingleProjectModal: React.FC<ShowSingleProjectModalProps> = ({
  closeModal,
  isVisible = false,
  project_id,
  taskData
}) => {

  return (
    <Portal>
      <Drawer
        isOpen={isVisible}
        onClose={() => closeModal()}
        position="right"
        minsize="80"
      >
        <div className="relative h-[100vh] flex flex-col">
          <DashboardDetails projectId={project_id} taskData={taskData} onBack={closeModal} />
        </div>
      </Drawer>
    </Portal>
  )

}

export default ShowSingleProjectModal;

